import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Internships = () => {
  const [internships, setInternships] = useState([]);
  const [formData, setFormData] = useState({
  title: '',
  company: '',
  description: '',
  applyLink: ''
});

  // const [formData, setFormData] = useState({ title: '', company: '', description: '' });
  const [loading, setLoading] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);

  // Retrieve the role and token from localStorage
  const role = localStorage.getItem('role') || 'student';
  const token = localStorage.getItem('token');

  // Fetch internships from the backend
  const fetchInternships = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/internships`);
      setInternships(response.data);
    } catch (error) {
      console.error('Error fetching internships:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInternships();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      alert('You must be logged in as a teacher to add an internship.');
      return;
    }
    if (!formData.title.trim() || !formData.company.trim() || !formData.description.trim()) {
      alert('Please fill in all fields.');
      return;
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/internships`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('Internship added successfully!');
      // Clear the form
      setFormData({ title: '', company: '', description: '' });
      setShowAddForm(false);
      // Refresh the list of internships
      fetchInternships();
    } catch (error) {
      console.error('Error adding internship:', error);
      alert('Error adding internship. Check the console for details.');
    }
  };

  const handleApply = (internship) => {
    alert(`Applied for ${internship.title}`);
    // Additional application logic can be added here
  };

  // Handler to delete an internship (only for teachers)
  const handleDelete = async (internshipId) => {
    if (!token) {
      alert('You must be logged in as a teacher to delete an internship.');
      return;
    }
    if (!window.confirm('Are you sure you want to delete this internship?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/internships/${internshipId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('Internship deleted successfully!');
      fetchInternships();
    } catch (error) {
      console.error('Error deleting internship:', error);
      alert('Error deleting internship. Check the console for details.');
    }
  };

  return (
    <div className="internships-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .internships-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .internships-container::before {
          content: '';
          position: absolute;
          top: 20%;
          right: 15%;
          width: 150px;
          height: 150px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 4s ease-in-out infinite;
        }

        .internships-container::after {
          content: '';
          position: absolute;
          bottom: 20%;
          left: 10%;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 3s ease-in-out infinite;
          animation-delay: 2s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes cardSlide {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .pulse-element {
          position: absolute;
          top: 50%;
          left: 5%;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: pulse 3s ease-in-out infinite;
        }

        .internships-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .main-title {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1.1rem;
          animation: slideIn 0.8s ease-out 0.2s both;
        }

        .action-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .internships-count {
          color: rgba(255, 255, 255, 0.9);
          font-size: 1rem;
          font-weight: 500;
        }

        .add-internship-btn {
          background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
          color: white;
          border: none;
          padding: 0.75rem 2rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          box-shadow: 0 4px 15px rgba(254, 107, 139, 0.3);
        }

        .add-internship-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(254, 107, 139, 0.4);
        }

        .form-container {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 2.5rem;
          margin-bottom: 2rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.5s ease-out;
          position: relative;
          overflow: hidden;
        }

        .form-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #FE6B8B, #FF8E53, #4ECDC4, #667eea);
          border-radius: 20px 20px 0 0;
        }

        .form-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .form-icon {
          width: 32px;
          height: 32px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.9rem;
        }

        .form-input {
          width: 100%;
          padding: 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          box-sizing: border-box;
          resize: vertical;
        }

        .form-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .form-textarea {
          min-height: 120px;
          font-family: inherit;
        }

        .form-actions {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .submit-btn {
          flex: 1;
          min-width: 150px;
          padding: 1rem 2rem;
          background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        }

        .submit-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(254, 107, 139, 0.4);
        }

        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .cancel-btn {
          padding: 1rem 2rem;
          background: rgba(107, 114, 128, 0.1);
          color: #374151;
          border: 2px solid rgba(107, 114, 128, 0.2);
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .cancel-btn:hover {
          background: rgba(107, 114, 128, 0.15);
          border-color: rgba(107, 114, 128, 0.3);
        }

        .internships-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
          margin-top: 2rem;
        }

        .internship-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 2rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          animation: cardSlide 0.5s ease-out;
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .internship-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }

        .internship-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(180deg, #FE6B8B, #FF8E53, #4ECDC4);
        }

        .card-header {
          display: flex;
          align-items: flex-start;
          margin-bottom: 1.5rem;
        }

        .card-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin-right: 1rem;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .card-content {
          flex: 1;
        }

        .internship-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .internship-company {
          font-size: 1rem;
          color: #667eea;
          font-weight: 600;
          background: rgba(102, 126, 234, 0.1);
          padding: 0.25rem 0.75rem;
          border-radius: 50px;
          display: inline-block;
          margin-bottom: 1rem;
        }

        .internship-description {
          color: #6b7280;
          line-height: 1.6;
          margin-bottom: 1.5rem;
          flex-grow: 1;
        }

        .card-actions {
          display: flex;
          gap: 0.75rem;
          align-items: center;
          justify-content: flex-end;
          margin-top: auto;
          padding-top: 1rem;
          border-top: 1px solid rgba(0,0,0,0.05);
        }

        .apply-btn {
          flex: 1;
          padding: 0.75rem 1.5rem;
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 0.95rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .apply-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

        .delete-btn {
          width: 40px;
          height: 40px;
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .delete-btn:hover {
          background: rgba(239, 68, 68, 0.2);
          transform: translateY(-2px);
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4rem;
        }

        .loading-content {
          text-align: center;
          color: white;
        }

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 1rem;
        }

        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .empty-icon {
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: white;
        }

        .empty-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: white;
          margin-bottom: 0.5rem;
        }

        .empty-description {
          color: rgba(255, 255, 255, 0.8);
          font-size: 1rem;
        }

        .section-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: white;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .section-icon {
          width: 32px;
          height: 32px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .internships-container {
            padding: 1rem 0.5rem;
          }
          
          .internships-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
          
          .form-container {
            padding: 2rem 1.5rem;
          }
          
          .internship-card {
            padding: 1.5rem;
          }
          
          .action-bar {
            flex-direction: column;
            align-items: stretch;
          }
          
          .form-actions {
            flex-direction: column;
          }
          
          .submit-btn {
            min-width: unset;
          }
        }
      `}</style>

      <div className="pulse-element"></div>
      
      <div className="internships-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14,6V4H20V6H14M20,8A2,2 0 0,1 22,10V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V10C2,8.89 2.9,8 4,8H7V6A2,2 0 0,1 9,4H15A2,2 0 0,1 17,6V8H20M4,10V19H20V10H4Z"/>
            </svg>
            Career Opportunities
          </div>
          
          <h1 className="main-title">
            <span className="gradient-text">Internship</span> Portal
          </h1>
          
          <p className="subtitle">
            Discover amazing internship opportunities and kickstart your career
          </p>
        </div>

        {/* Action Bar */}
        <div className="action-bar">
          <div className="internships-count">
            {internships.length} {internships.length === 1 ? 'Opportunity' : 'Opportunities'} Available
          </div>
          
          {role === 'teacher' && (
            <button 
              className="add-internship-btn"
              onClick={() => setShowAddForm(!showAddForm)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"/>
              </svg>
              {showAddForm ? 'Cancel' : 'Post Internship'}
            </button>
          )}
        </div>

        {/* Add Internship Form */}
        {role === 'teacher' && showAddForm && (
          <div className="form-container">
            <div className="form-title">
              <div className="form-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,6V4H20V6H14M20,8A2,2 0 0,1 22,10V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V10C2,8.89 2.9,8 4,8H7V6A2,2 0 0,1 9,4H15A2,2 0 0,1 17,6V8H20M4,10V19H20V10H4Z"/>
                </svg>
              </div>
              Post New Internship
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Job Title *</label>
                <input
                  type="text"
                  name="title"
                  className="form-input"
                  placeholder="e.g. Frontend Developer Intern"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Company Name *</label>
                <input
                  type="text"
                  name="company"
                  className="form-input"
                  placeholder="e.g. Google, Microsoft, StartupXYZ"
                  value={formData.company}
                  onChange={handleChange}
                  required
                />
              </div>
              
              {/* <div className="form-group">
                <label className="form-label">Job Description *</label>
                <textarea
                  name="description"
                  className="form-input form-textarea"
                  placeholder="Describe the role, responsibilities, requirements, and what the intern will learn..."
                  value={formData.description}
                  onChange={handleChange}
                  required
                />
              </div> */}
              <div className="form-group">
              <label className="form-label">Apply Link *</label>
              <input
                type="text"
                name="applyLink"
                className="form-input"
                placeholder="https://example.com/apply"
                value={formData.applyLink}
                onChange={handleChange}
                required
              />
            </div>

              
              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-btn"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"/>
                  </svg>
                  Post Internship
                </button>
                
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => {
                    setShowAddForm(false);
                    setFormData({ title: '', company: '', description: '' });
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Available Internships Section */}
        <div className="section-title">
          <div className="section-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,2A3,3 0 0,1 15,5V7H20A2,2 0 0,1 22,9V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V9C2,7.89 2.9,7 4,7H9V5A3,3 0 0,1 12,2M12,4A1,1 0 0,0 11,5V7H13V5A1,1 0 0,0 12,4Z"/>
            </svg>
          </div>
          Available Opportunities
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="loading-content">
              <div className="loading-spinner"></div>
              <p>Loading internships...</p>
            </div>
          </div>
        ) : internships.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14,6V4H20V6H14M20,8A2,2 0 0,1 22,10V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V10C2,8.89 2.9,8 4,8H7V6A2,2 0 0,1 9,4H15A2,2 0 0,1 17,6V8H20M4,10V19H20V10H4Z"/>
              </svg>
            </div>
            <h3 className="empty-title">No Internships Available</h3>
            <p className="empty-description">
              Check back later for new opportunities or contact your teachers for more information.
            </p>
          </div>
        ) : (
          <div className="internships-grid">
            {internships.map((internship, index) => (
              <div key={internship._id || internship.id} className="internship-card" style={{animationDelay: `${index * 0.1}s`}}>
                <div className="card-header">
                  <div className="card-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14,6V4H20V6H14M20,8A2,2 0 0,1 22,10V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V10C2,8.89 2.9,8 4,8H7V6A2,2 0 0,1 9,4H15A2,2 0 0,1 17,6V8H20M4,10V19H20V10H4Z"/>
                    </svg>
                  </div>
                  <div className="card-content">
                    <h3 className="internship-title">{internship.title}</h3>
                    <span className="internship-company">{internship.company}</span>
                  </div>
                </div>
                
                <p className="internship-description">
                  {internship.description}
                </p>
                
                <div className="card-actions">
                  {role === 'student' && (
                    <button
                      className="apply-btn"
                      onClick={() => handleApply(internship)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19Z"/>
                      </svg>
                      Apply Now
                    </button>
                  )}
                  {role === 'teacher' && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(internship._id || internship.id)}
                      title="Delete internship"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"/>
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Internships;